import React from 'react';
import { NiceFormGroup, QuestionWrapper } from './Components.styles';

const TextInput = ({
	questionNo,
	label,
	placeholder,
	onChange,
	name,
	value,
	required,
}) => {
	return (
		<NiceFormGroup>
			<QuestionWrapper>
				<div className="questionNo">{questionNo}.&nbsp;</div>
				<label>{label}</label>
			</QuestionWrapper>
			<input
				type="text"
				placeholder={placeholder}
				onChange={onChange}
				name={name}
				value={value}
				required={required}
			/>
		</NiceFormGroup>
	);
};

export default TextInput;
